import { FC } from 'react';
export const TeeTimeNoResults: FC<{
  roundId?: string;
}> = ({
  roundId
}) => <div className="p-8 text-center text-sm lg:text-base text-secondary" data-sentry-component="TeeTimeNoResults" data-sentry-source-file="tee-time-no-results.tsx">
    <h3 className="text-lg lg:text-xl font-bold text-gray-950 mb-4">
      Tee Time information {roundId ? `for round ${roundId} not yet` : 'not'} available
    </h3>
    <p>Tee time details will appear here once the host updates the information. Check back soon.</p>
  </div>;